import React from "react";
import "dayjs/locale/en-gb";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Dayjs } from "dayjs";
import { DateRange } from "@mui/x-date-pickers-pro";

// Type definitions
interface CustomDatePickerProps {
    value: DateRange<Dayjs>;
    onChange: (value: DateRange<Dayjs>) => void;
    errorStartDate?: string | null;
    errorEndDate?: string | null;
    startLabel?: string;
    endLabel?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ 
    value, 
    onChange, 
    errorStartDate, 
    errorEndDate, 
    startLabel = "Start Date", 
    endLabel = "End Date" 
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <DemoContainer components={["DateRangePicker"]}>
                <DateRangePicker
                    localeText={{ start: startLabel, end: endLabel }}
                    value={value}
                    onChange={onChange}
                    slotProps={{
                        textField: ({ position }) => ({
                            error: position === "start" ? Boolean(errorStartDate) : Boolean(errorEndDate),
                            helperText: position === "start" ? errorStartDate : errorEndDate,
                        }),
                    }}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
};

export default CustomDatePicker;
export type { CustomDatePickerProps }; 